//checks if the input has only whitespaces
function notOnlyWhitespaces(value) {
    return value.trim().length > 0;
}

export { notOnlyWhitespaces };
